import RestService from './RestService'

export default class EmailTemplatesService extends RestService {
    constructor() {
        super('email_templates')
    }

    list() {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '.json?t=' + Date.now() + '&app_id=' + webase.model.app.id
        return this.executeGet(url)
    }

}